import {
  NETWORK_SERVICE_ERROR_CODE,
  UNREACHABLE_SERVICE_ERROR_CODE,
  VALIDATION_ERROR_CODE,
  NOT_AUTHORIZED_CODE,
  BAD_REQUEST_ERROR_CODE,
  NOT_FOUND_ERROR_CODE,
  FORBIDDEN_ERROR_CODE,
  BadRequestError,
  NetworkServiceError,
  ServiceError,
  UnknownServiceError,
  UnreachableServiceError,
  ValidationError,
  NotAuthorized,
  NotFoundError,
  ForbiddenError
} from '../../model/errors';

export class ServiceErrorMapper {
  public map(error: any): ServiceError {
    const ERROR_MAPPING: {[key: number]: string} = {
      406: 'Not Acceptable',
      407: 'Proxy Authentication Required',
      409: 'Conflict',
      424: 'Failed dependency',
      429: 'Too many requests',
      500: 'Internal Server error',
    };
    if (typeof error === 'undefined' || error === null) {
      return new UnknownServiceError();
    }
    if (error instanceof ServiceError) {
      return error;
    }
    if (typeof error.status !== 'undefined' && error.status !== null) {
      const errorMessage = ERROR_MAPPING[error.status];
      if (errorMessage) {
        return new ServiceError(error.status, errorMessage, error);
      }
      if (error.status === NETWORK_SERVICE_ERROR_CODE) {
        return new NetworkServiceError();
      }
      if (error.status === UNREACHABLE_SERVICE_ERROR_CODE) {
        return new UnreachableServiceError();
      }
      if (error.status === VALIDATION_ERROR_CODE) {
        return new ValidationError(error);
      }
      if (error.status === NOT_AUTHORIZED_CODE) {
        return new NotAuthorized(error);
      }
      if (error.status === NOT_FOUND_ERROR_CODE) {
        return new NotFoundError();
      }
      if (error.status === BAD_REQUEST_ERROR_CODE) {
        return new BadRequestError();
      }
      if (error.status === FORBIDDEN_ERROR_CODE) {
        return new ForbiddenError();
      }
      return new ServiceError(error.status, 'Unknown Error', error);
    }
    // Map timeout from stream
    if ( error.message && error.message.toUpperCase().indexOf('TIMEOUT') !== -1) {
      return new NetworkServiceError();
    }
    return new UnknownServiceError(error);
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/services/mapper/service-error.mapper.ts